import {AxiosResponse} from "axios";
import {axiosInstance} from "../utils/axiosInstance";


export interface LoginRequest {
    username: string;
    password: string;
}

export interface LoginResponse {
    data: {
        access: string;
        refresh: string;
    }
}

export interface VerifyAuthRequest {
    token: string;
}


export async function login(req: LoginRequest): Promise<AxiosResponse<LoginResponse>> {
    const endpoint = 'auth';
    return await axiosInstance.post(endpoint, req);
}

export async function verifyAuth(req: VerifyAuthRequest): Promise<AxiosResponse> {
    return await axiosInstance.post('auth/verify', req);
}